import { render, staticRenderFns } from "./ProcedimentosSetting.vue?vue&type=template&id=6bfc26c0"
import script from "./ProcedimentosSetting.vue?vue&type=script&lang=js"
export * from "./ProcedimentosSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports